import { IndicatorFilterOperationOption } from "../__generated__/graphql";

  /**
   * Fonction d'association entre les opérations de filtre et les opérations GraphQL.
   * @param operation L'opération de filtre à associer.
   * @param negate Indique si l'opération est négative.
   * @returns L'opération GraphQL correspondante.
   */
export const operationToGraphqlMapping = (
    operation: IndicatorFilterOperationOption,
    negate: boolean
    ): string => {
    switch (operation) {
        case IndicatorFilterOperationOption.Equals:
        return negate ? 'neq' : 'eq';
        case IndicatorFilterOperationOption.Contains:
        return negate ? 'ncontains' : 'contains';
        case IndicatorFilterOperationOption.StartsWith:
        return negate ? 'nstartsWith' : 'startsWith';
        case IndicatorFilterOperationOption.EndsWith:
        return negate ? 'nendsWith' : 'endsWith';
        case IndicatorFilterOperationOption.GreaterThan:
        return negate ? 'ngt' : 'gt';
        case IndicatorFilterOperationOption.GreaterThanEquals:
        return negate ? 'ngte' : 'gte';
        case IndicatorFilterOperationOption.LesserThan:
        return negate ? 'nlt' : 'lt';
        case IndicatorFilterOperationOption.LesserThanEquals:
        return negate ? 'nlte' : 'lte';
        case IndicatorFilterOperationOption.IsDefined:
        return negate ? 'eq' : 'neq';
        default:
        return 'eq';
    }
}